import Element from "../../../../../components/categories/siakad/laporan_adab/elements/Home";
export default function Home() {
  
  return (
    <Element />
  );
}
